<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="12" v-for="(type, t) in types" :key="'type'+t">
          <v-card :loading="loading">
            <v-card-title primary-title :class="`${arabic?'arFont':'enFont'} pa-4 font-weight-bold primary white--text`">
              {{i18n[type]}}
              <v-spacer></v-spacer>
              <v-btn color="success" depressed @click="typesPannels[type]=!typesPannels[type]">
                <v-icon v-if="!typesPannels[type]">expand_more</v-icon>
                <v-icon v-else>expand_less</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="typesPannels[type]" class="px-3">
              <v-row class="pa-0">
                <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-4`" style="font-size:16px;line-height:2;">
                  <v-row class="pa-0 align-center">
                    <v-col cols="12" v-for="(item, u) in typeitems[type]" :key="'typeitems-'+u">
                      <v-row class="pa-0">
                        <v-col cols="2" class="py-0">
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            @keypress="noSpace($event)"
                            :label="i18n.slug"
                            v-model="item.slug"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="py-0">
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            :label="i18n.arabic"
                            v-model="item.ar"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="py-0">
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            :label="i18n.english"
                            v-model="item.en"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="py-0">
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            :label="i18n.french"
                            v-model="item.fr"
                          ></v-text-field>
                        </v-col>
                        
                        <v-col cols="3" class="py-0">
                          <v-btn v-if="!item.id" color="success" block text @click="save(type, item)">
                            <v-icon left>save</v-icon>
                            <span>{{i18n.save}}</span>
                          </v-btn>
                          <v-btn v-if="item.id" color="success" block text @click="update(type, item)">
                            <v-icon left>save</v-icon>
                            <span>{{i18n.update}}</span>
                          </v-btn>
                        </v-col>
                        <v-col cols="1" class="py-0">
                          <v-btn color="error" icon text disabled>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-btn 
                    depressed
                    block
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                    :class="`${arabic?'arFont':'enFont'}`"
                    @click="()=>{if(
                        !typeitems[type]) typeitems[type] = [];
                        typeitems[type].push({ })
                      }"
                  >{{i18n.AddItem}}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging },
  data() {
    return {
      loading:false,
      dialog:false,
      types:['countries', 'statuses', 'programs', 'roles'],
      typesPannels:{
        countries:false,
        statuses:false,
        programs:false,
        roles:false,
      },
      typeitems:{
        countries:[],
        statuses:[],
        programs:[],
        roles:[],
      },
      
    }
  },
  
  methods: {
    async update(type, item){
      console.log(type, item)
      await this.updateResource(type, item)
      this.loadItems()
    },
    getFormat(d){
      return format(d)
    },
    async save(type, item){
      console.log(type, item)
      await this.postResource(type, item)
      this.loadItems()
    },
    async postResource(type, r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource: '/' + type + `${r.id ? '/' + r.id : ''}`, value:r})
        this.loading = false
        res()
      })
    },
    async updateResource(type, r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('putResource', {resource: '/' + type + `/${r.id}`, value:r})
        this.loading = false
        res()
      })
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.types;
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            this.typeitems[f] = [];
            let t = await this.$store.dispatch('getResource', {resource:`/${f}`})
            if(!t.error)
            console.log(t)
            this.typeitems[f] = t
          }
          res(true)
        })()
      })
    },
    
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    noSpace(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode == 32 || charCode == 19 || charCode == 9) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getItems(items) {
      return this[items]
    },
    getExtraItems(items){
      return this.extraFields.filter(x=>x.items == items)[0].data
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
  },
  watch:{
    
  },
  computed:{

    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>